export const EnvironmentKeys = {
    VUE_APP_ENABLE_REGISTER: "VUE_APP_ENABLE_REGISTER",
    VUE_APP_ENABLE_GROUP_CHECK: "VUE_APP_ENABLE_GROUP_CHECK",
    VUE_APP_GOOGLE_CLIENT_ID: "VUE_APP_GOOGLE_CLIENT_ID"
}
